// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__2qIEo","disabled":"Button_disabled__GwXUN"};